import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator, createClashingRulesValidationFunctionNew } from './TagRulesCommon'

const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "UpdateProductMetafieldFromTagGroup",
    title: "Update Product Metafield From Tag Group",
    description: "Automatically set metafield value based on tag belonging to a Tag Group.",
    example: null,
    additional: [],
    legacy: false,
    inProgress: false,
    previewType: "ProductMetafields",
    dataPermissions: ["products"],
    allowPreview: false,
    tags: ["Products", "Metafields"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "UpdateProductMetafieldFromTagGroup",
                metafieldNamespaceAndKey: null,
                metafieldType: "single_line_text_field",
                tagGroupPrefix: "",
                removeMetafieldValueWhenTagIsMissing: false,
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {

                    if (rule.settings.metafieldNamespaceAndKey == null || !/^(.+\..+)$/.test(rule.settings.metafieldNamespaceAndKey)) {
                        errors["metafieldNamespaceAndKey"] = "Incorrect metafield namespace and key";
                    }

                    if (rule.settings.metafieldType == null || rule.settings.metafieldType === "") {
                        errors["metafieldType"] = "Metafield type is required";
                    }

                    if (rule.settings.tagGroupPrefix == null || rule.settings.tagGroupPrefix === "") {
                        errors["tagGroupPrefix"] = "Tag group prefix is required";
                    }
                }
            ], createClashingRulesValidationFunctionNew("PRODUCT"));
    }
};

export default ruleDefinition;